import React, {
  // useContext
} from 'react'
import logo from '../assets/logo-inst.png'
// import LoginContext from '../context/Login/LoginContext'

const Header = () => {
  
  // const loginContext = useContext(LoginContext)
  // const {CloseSession} = loginContext

  return (

    <div className="container">
      <header className="d-flex flex-wrap justify-content-center py-3 mb-4 border-bottom">
        <div className="col-2"></div>
        <div className="col-12">
          <a href="/credito" className="d-flex align-items-center justify-content-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none">
            <img className="image-logo-institutioanl" src={logo} alt="" />       
          </a>
        </div>
        <div className="col-2 text-center">
          
        </div>

        <ul className="nav nav-pills">
          
        </ul>
      </header>
    </div>
  )
}

export default Header
